/**
 * @module vuetifyモジュール
 */
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueI18n from 'vue-i18n';
import { jpn } from '../i18n/jpn.js';
import { eng } from '../i18n/eng.js';
import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import ja from 'vee-validate/dist/locale/ja.json';
import EyeSvg from '@/components/icons/EyeSvg';
import EyeOffSvg from '@/components/icons/EyeOffSvg';

Vue.use(Vuetify);
Vue.use(VueI18n);

// バリデーション関連
extend('required', required);
localize('ja', ja);
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

export default new Vuetify({
  lang: {
    locales: { ja: jpn, en: eng },
    current: 'ja',
  },
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    values: {
      custom_eye: {
        component: EyeSvg,
      },
      custom_eye_off: {
        component: EyeOffSvg,
      },
    },
  },
});
